



























































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import ConfirmPaymentItem from "./components/confirm-payment.vue";
import RegisterInvoice from "./components/register-invoice.vue";

const service = namespace("service");
const store = namespace("store");
const setting = namespace("setting");
const user = namespace("user");
const purchase = namespace("purchase");
const app = namespace("app");

@Component({
  components: {
    StepList,
    ConfirmPaymentItem,
    RegisterInvoice
  }
})
export default class PurchaseView extends Vue {
  @purchase.Action purchaseComplete;
  @purchase.Action getPurchaseDetail;
  @purchase.Action purchaseCancel;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  splitThousands = splitThousands;
  get breadData() {
    return [{ name: "采购管理", path: "/purchase/index" }, { name: "查看采购单" }];
  }
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  paymentData: any = {};
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.purchaseCancel({
        purchaseNo: this.orderId
      }).then(data => {
        this.$message.success("取消成功");
        this.init();
      });
    }
  }
  handlePaymentConfirmClick(data) {
    console.log(data);
    let params = {
      orderList:
        data.settleType === 1
          ? [{ orderNo: this.orderId }]
          : data.selectedRows.map(item => {
              item.orderNo = item.purchaseNo;
              return item;
            }),
      paidList: [
        {
          paidAmount: data.settleType === 1 ? this.detailData.purchaseAmount : 0,
          paidMethod: data.paidMethod
        }
      ],
      remark: ""
    };
    this.setPaymentBtnLoading(true);
    this.createPurchasePayment(params)
      .then(data => {
        this.$message.success("付款成功");
        this.showComfirmPayment = false;
        this.init();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(data => {
        this.$message.success(this.$t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.init();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  get orderId() {
    return this.$route.params.id;
  }
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  emptyToLine = emptyToLine;
  detailData: any = { purchaseStatus: "2", photoList: [] };
  handleComplete() {
    this.btnStartLoading();
    this.purchaseComplete({
      purchaseNo: this.orderId
    })
      .then(data => {
        this.$message.success(this.$t("warehouse.inbound-success") as string);
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleComfirmPaymentShow() {
    this.showComfirmPayment = true;
  }
  handleRegisterInvoice() {
    this.showRegisterInvoice = true;
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  init() {
    this.getPurchaseDetail({
      purchaseNo: this.orderId
    }).then(data => {
      this.detailData = data.data;
    });
  }
}
